// src/shared_new/modules/SelectedValueModule.jsx
import React from "react";
import { Box, useTheme } from "@mui/material";
import PerlLabelSmall from "../components/PerlLabelSmall";
import PerlLabelMedium from "../components/PerlLabelMedium";

/**
 * SelectedValueModule Component
 *
 * Displays a label-value pair in a consistent format
 * Used for showing selected/entered values in forms
 *
 * @param {string} label - The field label (e.g., "Product Name")
 * @param {string|ReactNode} value - The selected/entered value (can be string or React component)
 * @param {object} sx - Additional styles
 */
export default function SelectedValueModule({ label, value, sx = {} }) {
  const theme = useTheme();
  const perlColors = theme.custom?.perlColors || {};

  // Don't render if no value provided
  if (!value) return null;

  // Check if value is a React element/component
  const isReactNode = React.isValidElement(value) || typeof value === 'object';

  return (
    <Box sx={{ mb: 2, minHeight: "60px", ...sx }}>
      <PerlLabelSmall sx={{ mb: 0.5 }}>{label}</PerlLabelSmall>
      {isReactNode ? (
        <Box sx={{ mt: 1 }}>{value}</Box>
      ) : (
        <PerlLabelMedium
          sx={{
            color: perlColors.textSecondary || "#798286",
            whiteSpace: "pre-line",
            wordBreak: "break-word",
            overflowWrap: "anywhere",
          }}
        >
          {value}
        </PerlLabelMedium>
      )}
    </Box>
  );
}
